import { Button, DataSource, Image, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGooglePlaces extends Layout {
    buttonSearch: Button;
    imageWarning: Image;
    labelInfo: Label;
    labelPageHeader: Label;
    panelHeader: Panel;
    panelSearchGoogle: Panel;
    panelWarning: Panel;
    sourceGooglePlaces: DataSource;
    tableGooglePlaceSearch: Table;
    textboxGoogleSearch: Textbox;
}
